import { useEffect } from "react";
import { useDispatch } from "react-redux";

import useCurrentUser from "../../../hooks/useCurrentUser";
import { firestore } from "../../../init/firebase";
import { AppResource, ParticipantType } from "../../../types/resource.types";
import { UserRole } from "../../../types/user.types";
import { syncChatRooms } from "../redux/reducer/chat.reducer";
import chatQueries from "./chatQueries";

const useSyncChatRooms = () => {
  const dispatch = useDispatch();
  const { user } = useCurrentUser();

  useEffect(() => {
    let unsubscribeToChatRoom: any;

    if (user.id) {
      unsubscribeToChatRoom = chatQueries
        .getChatRooms({
          userId: user.id,
          type:
            user.role === UserRole.admin
              ? ParticipantType.admin
              : user.role === UserRole.sportClub
              ? ParticipantType.sportsClubs
              : user.role === UserRole.store
              ? ParticipantType.brands
              : user.role === UserRole.academy
              ? ParticipantType.academies
              : user.role === UserRole.coach
              ? ParticipantType.coaches
              : user.role === UserRole.gym
              ? ParticipantType.gyms
              : ParticipantType.entertainments,
          limit: 1,
        })
        .onSnapshot({
          next: async (snapshot) => {
            if (!snapshot.empty) {
              const roomSnapshot = snapshot.docs[0];
              const clientId = roomSnapshot
                .data()
                .participants.filter((participantId: string) => user.id !== participantId)[0];
              const clientSnapshot = await firestore.collection(AppResource.clients).doc(clientId).get();
              const room = {
                ...roomSnapshot.data(),
                id: roomSnapshot.id,
                ref: roomSnapshot.ref,
                client: clientSnapshot.data(),
              };
              dispatch(syncChatRooms(room));
            }
          },
          error(ex: any) {
            console.log(ex.message);
          },
        });
    }

    return () => {
      if (unsubscribeToChatRoom) return unsubscribeToChatRoom();
    };
  }, [user.id]);
};

export default useSyncChatRooms;
